import { render, staticRenderFns } from "./composer-atencao.vue?vue&type=template&id=0e1247d8&scoped=true&"
import script from "./composer-atencao.vue?vue&type=script&lang=js&"
export * from "./composer-atencao.vue?vue&type=script&lang=js&"
import style0 from "./composer-atencao.vue?vue&type=style&index=0&id=0e1247d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1247d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e1247d8')) {
      api.createRecord('0e1247d8', component.options)
    } else {
      api.reload('0e1247d8', component.options)
    }
    module.hot.accept("./composer-atencao.vue?vue&type=template&id=0e1247d8&scoped=true&", function () {
      api.rerender('0e1247d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/composer-atencao/composer-atencao.vue"
export default component.exports